import { useParams, useNavigate } from "react-router-dom";
import friendsData from "../data/friends.json"; // your array source

import "./FriendProfile.css";

export default function FriendProfile() {
  const { id } = useParams();
  const navigate = useNavigate();

  const friend = friendsData.find((f) => f.id.toString() === id);

  if (!friend) {
    return <p>Friend not found 😢</p>;
  }

  return (
    <div className="profile-page">
      <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
      <div className="profile-card">
        <img src={friend.photo} alt={friend.name} className="profile-photo" />

        <h1>{friend.name}</h1>
        <p className="profile-subtext">
          {friend.gender} • {friend.heightStr} • ${friend.income.toLocaleString()}
        </p>

        <div className="profile-tags">
          {friend.traits.map((t) => (
            <span key={t} className="profile-tag">{t}</span>
          ))}
        </div>

        <div className="profile-bio">
          <p>
            {friend.bio || "No bio yet — but rumor has it they’re quite the catch 😉"}
          </p>
        </div>

        <button className="wishlist-btn">💖 Add to Wishlist</button>
      </div>
    </div>
  );
}
